import { render, staticRenderFns } from "./HistoryEventsList.vue?vue&type=template&id=68707dfe"
import script from "./HistoryEventsList.vue?vue&type=script&lang=js"
export * from "./HistoryEventsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports